<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Fees Installment</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="fees_installment_list" class="elevation-1 mytable" dense
        :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on">Add Fees Intsallment</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-autocomplete dense rounded outlined :items="aylist" item-text="ay" item-value="id"
                          v-model="addedItem.ay" label="Select Academic Year"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete dense rounded outlined :items="aylist" item-text="ay" v-model="editedItem.ay"
                          label="Select Academic Year"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-text-field dense rounded outlined v-model="addedItem.name_of_installment"
                          label="Please Enter Installment Name"
                          hint="For Ex. Installment 1, Installment 2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field dense rounded outlined v-model="editedItem.name_of_installment"
                          label="Please Enter Installment Name"
                          hint="For Ex. Installment 1, Installment 2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {

  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      name_of_installment: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    fees_installment_list: [],
    academicYear: null,
    aylist: null,
    headers: [
      {
        text: "Fees Installment No.",
        align: "left",
        sortable: false,
        value: "installment_no",
      },
      {
        text: "Installment Name",
        align: "left",
        sortable: false,
        value: "name_of_installment",
      },
      {
        text: "Academic Year",
        align: "left",
        sortable: false,
        value: "ay",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    editedIndex: -1,
    addedItem: {
      name_of_installment: "",
      ay: null,
    },
    editedItem: {
      id: "",
      name_of_installment: "",
      ay: null,
      isactive: true,
    },
    defaultItem: {
      id: "",
      name_of_installment: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Fees Installment"
        : "Edit Fees Installment";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.name_of_installment = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AccountingAndFees/getFeesInstallmet")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            this.fees_installment_list = res.data.fees_installment_list;
            this.academicYear = res.data.academicYear;
            this.aylist = res.data.aylist;
            this.addedItem.ay = res.data.academicYear;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.fees_installment_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.fees_component_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.fees_component_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    hasWhiteSpace(s) {
      var status = false;
      var reWhiteSpace = new RegExp(/^\s+$/);

      // Check for white space
      if (reWhiteSpace.test(s)) {
        // alert("Please Check Your Fields For Spaces");
        return true;
      }
      return false;
    },
    save() {
      if (this.editedIndex > -1) {
        if (this.editedItem.ay == "" || this.editedItem.ay == null) {
          this.showSnackbar("#b71c1c", "Please select Academic Year!!!");
          return false;
        }
        if (
          this.editedItem.name_of_installment == "" ||
          this.editedItem.name_of_installment == null
        ) {
          this.showSnackbar("#b71c1c", "Please enter Installment Name!!!");
          return false;
        } else {
          if (this.isValidated()) {
            axios
              .post("/AccountingAndFees/editFeesInstallmet", this.editedItem)
              .then((res) => {
                if (res.data.msg == "200") {
                  if (res.data.status.code == "SUCCESS") {
                    // Object.assign(
                    //   this.fees_component_list[this.editedIndex],
                    //   this.editedItem
                    // );
                    this.onLoad();
                    this.showSnackbar(
                      "#4caf50",
                      "Fees Installment updated successfully..."
                    ); // show snackbar on success
                  } else {
                    this.onLoad();
                    this.showSnackbar(
                      "#b71c1c",
                      "Fees Installment already present!!!"
                    );
                  }
                }
              })
              .catch((error) => {
                window.console.log(error);
              })
              .finally(() => {
                this.editedItem.feesComponent = "";
                this.editedItem.feesComponentcategory = null;
                this.editedItem.ay = null;
              });

            this.close();
          }
        }
      } else {
        if (this.addedItem.ay == "" || this.addedItem.ay == null) {
          this.showSnackbar("#b71c1c", "Please select Academic Year!!!");
          return false;
        }

        if (
          this.addedItem.name_of_installment == "" ||
          this.addedItem.name_of_installment == null
        ) {
          this.showSnackbar("#b71c1c", "Please enter Installment Name!!!");
          return false;
        }
        if (this.hasWhiteSpace(this.addedItem.name_of_installment)) {
          this.showSnackbar("#b71c1c", "Please enter Installment Name!!!");
          return false;
        } else {
          axios
            .post("/AccountingAndFees/saveFeesInstallmet", this.addedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                //   this.fees_component_list.push(this.addedItem);
                this.showSnackbar(
                  "#4caf50",
                  "Fees Installment added successfully..."
                ); // show snackbar on success
                this.onLoad();
                // this.addedItem.fees_component_super_master_list = "";
                // this.addedItem.ay = "";
                // this.addedItem.feesComponentcategory = "";
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Fees Installment already present!!!"
                );
                // show snackbar on error
              }
            })

            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              this.addedItem.name_of_installment = "";
              this.addedItem.ay = null;
            });

          this.close();
        }
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.name_of_installment) {
        return true;
      } else {
        if (!this.editedItem.name_of_installment) {
          this.errorMsg.name_of_installment = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
